import React from 'react';

export default function Tooltips({ type, position = 'bottom-left', title = 'Tooltip', style }) {
    function renderSwitch() {
        switch (type) {
            
            case 'HSN/TSN':
                return (
                    <div className="sn-info uk-flex-middle" style={style}>
                        <button
                            className="focus"
                            style={{
                                backgroundColor:"transparent",
                                border: "none",
                                display: "flex",
                                justifyContent:"center",
                                alignItems:"center",
                                minHeight:24, 
                            }}
                            aria-describedby="tooltip_hsn_tsn"
                            aria-label='HSN/TSN Tooltip'
                                // style={{ color: "rgb(45, 166, 223)" }}
                                uk-tooltip={`
                                pos: ${position}; 
                                cls: sn-tooltip uk-active;
                                title: <div role="tooltip" id="tooltip_hsn_tsn">Die Herstellerschlüsselnummer (HSN) und die Typschlüsselnummer (TSN) finden Sie in Ihrem Fahrzeugschein im Feld 2.<img src='/HSN_TSN.png' />Bild: bussgeldkatalog.org</div>`}>
                            <i
                                className="fa fa-info-circle fa-lg"
                                aria-hidden="true"
                                focusable="false"
                            ></i>
                        </button>
                    </div>
                );
            case 'HSN':
                return (
                    <div className="sn-info uk-flex-middle" style={style}>
                        <button 
                            className="focus"
                            style={{
                                backgroundColor:"transparent",
                                border: "none",
                                display: "flex",
                                justifyContent:"center",
                                alignItems:"center",
                                minHeight:24, 

                            }}
                            aria-label='HSN Tooltip'
                            aria-describedby="tooltip_hsn"
                                // style={{  color: "rgb(45, 166, 223)" }}
                                uk-tooltip={`
                                pos: ${position}; 
                                cls: sn-tooltip uk-active;
                                title: <div role="tooltip" id="tooltip_hsn">Die Herstellerschlüsselnummer (HSN) und die Typschlüsselnummer (TSN) finden Sie in Ihrem Fahrzeugschein im Feld 2.<img src='/HSN.png' />Bild: bussgeldkatalog.org</div>`}>
                            <i
                                className="fa fa-info-circle fa-lg"
                                aria-hidden="true"
                                focusable="false"
                            ></i>
                        </button>
                    </div>
                );
            case 'TSN':
                return (
                    <div className="sn-info uk-flex-middle" style={style}>
                        <button
                            className="focus"
                            style={{
                                backgroundColor:"transparent",
                                border: "none",
                                display: "flex",
                                justifyContent:"center",
                                alignItems:"center",
                                minHeight:24, 
                            }}
                            aria-label='TSN Tooltip'
                            aria-describedby="tooltip_tsn"
                            // style={{  color: "rgb(45, 166, 223)" }}
                            uk-tooltip={`
                                pos: ${position}; 
                                cls: sn-tooltip uk-active;
                                title: <div role="tooltip" id="tooltip_tsn">Die Herstellerschlüsselnummer (HSN) und die Typschlüsselnummer (TSN) finden Sie in Ihrem Fahrzeugschein im Feld 2.<img src='/TSN.png' />Bild: bussgeldkatalog.org</div>`}
                        >
                            <i
                                className="fa fa-info-circle fa-lg"
                                aria-hidden="true"
                                focusable="false"
                            ></i>
                        </button>
                    </div>
                );
            case 'FIN':
                return (
                    <div className="sn-info uk-flex-middle" style={style}>
                        <button
                            className="focus"
                            style={{
                                backgroundColor:"transparent",
                                border: "none",
                                display: "flex",
                                justifyContent:"center",
                                alignItems:"center",
                                minHeight:24, 
                            }}
                            aria-label='FIN Tooltip'
                            aria-describedby="tooltip_fin"
                            // style={{ color: "rgb(45, 166, 223)" }}
                            uk-tooltip={`
                                pos:  ${position}; 
                                cls: sn-tooltip uk-active;
                                container: body;
                                title: <div role="tooltip" id="tooltip_fin">Die FIN-Abfrage ermöglicht eine noch genauere Berechnung der Servicekosten im Vergleich zur Abfrage über HSN/TSN bzw. die manuelle Eingabe.<br><br>Die Fahrzeugidentifikationsnummer (FIN) finden Sie in Ihrem Fahrzeugschein (Zulassungsbescheinigung Teil I) im Feld E.<img src='/FIN.png' /></div>`}
                            >
                            <i
                                className="fa fa-info-circle fa-lg"
                                aria-hidden="true"
                                focusable="false"
                            ></i>
                        </button>
                    </div>
                );

            case 'Gesamtsumme':
                return (
                    <div className="sn-info uk-flex-middle" style={style}>
                        <button
                            className="focus"
                            style={{
                                border: "none",
                                display: "flex",
                                justifyContent:"center",
                                alignItems:"center",
                                minHeight:24,  
                                backgroundColor:"inherit", 
                                borderRadius: "50%" , 
                                paddingLeft: '10px' 
                            }}
                            aria-label='FIN Tooltip'
                            aria-describedby="tooltip_gesamtsumme"
                                uk-tooltip="
                                    pos: bottom-left; 
                                    cls: sn-tooltip uk-active;
                                    container: body;
                                    title: <div role='tooltip' id='tooltip_gesamtsumme'>Die angegebene vorraussichtliche Gesamtsumme bezieht sich auf die ausgewiesenen Services und Teile und kann Änderungen unterliegen, die sich erst vor Ort in Ihrer Werkstatt ergeben. Ggf. können vor Ort zusätzliche Leistungen notwendig werden, für die weitere Kosten entstehen können. Sollten Zusatzprodukte angeboten und gewählt worden sein, werden diese nicht in der Gesamtsumme aufgeführt und vor Ort berechnet.</div>"
                        >
                            <i
                                className="fa fa-info-circle fa-lg"
                                aria-hidden="true"
                                focusable="false"
                            ></i>
                        </button>
                    </div>
                );
            default:
                return (
                    
                    <>
                    {title != 'Tooltip' && title != '' && (
                    <div className="sn-info uk-flex-middle" style={style}>
                        <button
                            className="focus"
                            style={{
                                border: "none",
                                display: "flex",
                                justifyContent:"center",
                                alignItems:"center",
                                minHeight:24, 
                                backgroundColor:"white", 
                                borderRadius: "50%" ,  
                            }}
                            aria-label='FIN Tooltip'
                            aria-describedby="tooltip_gesamtsumme"
                                uk-tooltip={`
                                pos:  ${position}; 
                                cls: sn-tooltip uk-active;
                                container: body;
                                title: <div role='tooltip' id='tooltips'>${title.replace(/\n{1}/g,'<br>') }</div>`}
                        >
                            <i
                                className="fa fa-info-circle fa-lg"
                                aria-hidden="true"
                                focusable="false"
                            ></i>
                        </button>
                    </div>
                    )}
                    </>
                );
        }
    }
    return <>{renderSwitch()}</>;
}
 